import { render, staticRenderFns } from "./class_detail.vue?vue&type=template&id=3f63dcdc&"
import script from "./class_detail.vue?vue&type=script&lang=js&"
export * from "./class_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports